import {
    Button, Form, Input, PageHeader,
} from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { ETourTargetType, ETourType, EUrlMatchStrategy } from '../../../../enums/tours.enum';
import { ToursContext } from '../../context/tours.context';
import TourCommonFields from '../TourCommonFields';
import showTourConfirmModal from '../ConfirmModal';

const OnVisitTour: React.FC = () => {
    const {
        countries,
        loadingCountries,
        fetchWorkspacesAsync,
        tourSelected,
        saveTour,
        updateTour,
        savingTour,
    } = useContext(ToursContext);

    const [form] = Form.useForm();
    const [targetType, setTargetType] = useState<ETourTargetType>(tourSelected?.targetType || ETourTargetType.COUNTRY);
    const [applyToNewWorkspacesOnly, setApplyToNewWorkspacesOnly] = useState<boolean>(false);

    const rules = [
        { required: true, message: 'This field is required' },
    ];

    const onFinish = (values: any) => {
        if (tourSelected) {
            updateTour(tourSelected._id as string, {
                ...values,
                type: ETourType.ON_VISIT,
                urlMatchStrategy: EUrlMatchStrategy.EXACT,
                applyToNewWorkspacesOnly: targetType === ETourTargetType.WORKSPACE ? applyToNewWorkspacesOnly : false,
                newWorkspaceReferenceDate:
                targetType === ETourTargetType.WORKSPACE && applyToNewWorkspacesOnly
                    ? new Date()
                    : null,
            });
        } else {
            saveTour({
                ...values,
                type: ETourType.ON_VISIT,
                urlMatchStrategy: EUrlMatchStrategy.EXACT,
                applyToNewWorkspacesOnly: targetType === ETourTargetType.WORKSPACE ? applyToNewWorkspacesOnly : false,
                newWorkspaceReferenceDate:
                targetType === ETourTargetType.WORKSPACE && applyToNewWorkspacesOnly
                    ? new Date()
                    : null,
            });
        }
    };

    useEffect(() => {
        if (tourSelected) {
            form.setFieldsValue({
                name: tourSelected.name,
                description: tourSelected.description,
                targetType: tourSelected.targetType,
                targetIds: tourSelected.targetIds,
                loomUrl: tourSelected.loomUrl || '',
                scribeUrl: tourSelected.scribeUrl || '',
                startUrl: tourSelected.startUrl || '',
            });
            setTargetType(tourSelected.targetType);
            if (tourSelected.applyToNewWorkspacesOnly) {
                setApplyToNewWorkspacesOnly(true);
            }
        } else {
            form.resetFields();
            setTargetType(ETourTargetType.COUNTRY);
        }
    }, [tourSelected]);

    const handleConfirmSubmit = () => {
        const targetIds = form.getFieldValue('targetIds') || [];

        showTourConfirmModal({
            targetType,
            targetIds,
            countries,
            applyToNewWorkspacesOnly,
            tourSelected,
            onConfirm: () => form.submit(),
        });
    };

    return (
        <PageHeader
            title={tourSelected ? `Edit Tour: ${tourSelected.name}` : 'Create Tour'}
            style={{ padding: 0 }}
            footer={(
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <TourCommonFields
                        tourSelected={tourSelected}
                        countries={countries}
                        loadingCountries={loadingCountries}
                        fetchWorkspacesAsync={fetchWorkspacesAsync}
                        targetType={targetType}
                        onChangeTargetType={setTargetType}
                        applyToNewWorkspacesOnly={applyToNewWorkspacesOnly}
                        onChangeApplyToNewWorkspaces={setApplyToNewWorkspacesOnly}
                        extraRightTop={(
                            <Form.Item
                                name="startUrl"
                                label="Where to start the tour"
                                help="Define the page where the tour will start. Example: /home"
                                rules={rules}
                            >
                                <Input placeholder="/home" type="text" />
                            </Form.Item>
                        )}
                    />
                </Form>
            )}
            extra={[
                <Button
                    block
                    type="primary"
                    size="small"
                    loading={savingTour}
                    onClick={handleConfirmSubmit}
                >
                    {tourSelected ? 'Update' : 'Create'}
                </Button>,
            ]}
        />
    );
};

export default OnVisitTour;
